import React from 'react'
import { Spinner } from 'react-bootstrap'
import { ExclamationTriangle } from 'react-bootstrap-icons'

/**
 * The footer contract: optional context on the left, then Cancel, then exactly
 * one primary action. Validation failures get their own row above the buttons —
 * the footer is sticky, so an error raised while the user is scrolled to the
 * top of a long form is still visible.
 *
 * `formId` links the submit button to a <form> living in the modal body (see
 * AppModal), which is what lets the button sit in the footer at all.
 */
const ModalActions = ({
  onCancel,
  cancelLabel = 'Cancel',
  submitLabel = 'Save',
  onSubmit,
  formId,
  loading = false,
  disabled = false,
  tone = 'primary',
  error,
  note,
  extra,
}) => (
  <>
    {error && (
      <div className='app-modal__footer-error' role='alert'>
        <ExclamationTriangle className='app-modal__footer-error-icon' />
        <span>{error}</span>
      </div>
    )}

    {note && <span className='app-modal__footer-note'>{note}</span>}

    {extra}

    {onCancel && (
      <button
        type='button'
        className='btn btn-light'
        onClick={onCancel}
        disabled={loading}
      >
        {cancelLabel}
      </button>
    )}

    {submitLabel && (
      <button
        type={formId ? 'submit' : 'button'}
        form={formId}
        className={`btn btn-${tone}`}
        onClick={formId ? undefined : onSubmit}
        disabled={loading || disabled}
      >
        {loading && (
          <Spinner
            className='spinner-border-sm me-2'
            animation='border'
            variant='light'
          />
        )}
        {submitLabel}
      </button>
    )}
  </>
)

export default ModalActions
